var f = Object.defineProperty, p = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
var m = (t, o, e) => o in t ? f(t, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[o] = e, i = (t, o) => {
  for (var e in o || (o = {}))
    s.call(o, e) && m(t, e, o[e]);
  if (r)
    for (var e of r(o))
      g.call(o, e) && m(t, e, o[e]);
  return t;
}, a = (t, o) => p(t, c(o));
import h, { forwardRef as n } from "react";
import b from "../lib/IconBase.mjs";
import d from "../defs/GithubLogo.mjs";
const l = n((t, o) => /* @__PURE__ */ h.createElement(b, a(i({ ref: o }, t), { weights: d })));
l.displayName = "GithubLogo";
export {
  l as GithubLogo
};
